import type { Record } from "~/tools/record";
import { theme } from "~/tools/twin-migration";

import type { LogSeverity } from "../common/openapi";

const LOG_SEVERITY_COLOR: Record<LogSeverity, string> = {
	ERROR: theme("colors.red.500"),
	WARNING: theme("colors.orange.500"),
	OTHER: theme("colors.graphite.500"),
};

export const logSeverityToColor = (severity: LogSeverity): string => LOG_SEVERITY_COLOR[severity];

const LOGS_SEVERITY_LABEL: Record<LogSeverity, string> = {
	ERROR: "Errors",
	WARNING: "Warnings",
	OTHER: "Other",
};

export const logSeverityToLabel = (severity: LogSeverity): string => LOGS_SEVERITY_LABEL[severity];
